import React, { ReactNode } from 'react';

import { useGetFeatureEnabledForCountry } from '../common/hooks/useGetFeatureEnabledForCountry';

type RenderOnlyForCountryProps = {
  children: ReactNode;
};

const RenderOnlyForCreditEnabledCountry = ({
  children,
}: RenderOnlyForCountryProps) => {
  const { isCreditSystemEnabled } = useGetFeatureEnabledForCountry();

  return isCreditSystemEnabled ? <>{children}</> : null;
};

const RenderOnlyForVIPMembershipEnabledCountry = ({
  children,
}: RenderOnlyForCountryProps) => {
  const { isVIPMembershipEnabled } = useGetFeatureEnabledForCountry();

  return isVIPMembershipEnabled ? <>{children}</> : null;
};

const RenderBasedOnCompanyCountry = {
  CreditEnabledCountryOnly: RenderOnlyForCreditEnabledCountry,
  VIPMembershipEnabledCountryOnly: RenderOnlyForVIPMembershipEnabledCountry,
};

export default RenderBasedOnCompanyCountry;
